import { render, staticRenderFns } from "./RecuperarSenha.vue?vue&type=template&id=5f3c9274&scoped=true&"
import script from "./RecuperarSenha.vue?vue&type=script&lang=js&"
export * from "./RecuperarSenha.vue?vue&type=script&lang=js&"
import style0 from "./RecuperarSenha.vue?vue&type=style&index=0&id=5f3c9274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c9274",
  null
  
)

export default component.exports